import React from "react";
import { adminTheme } from "./adminTheme";

type PillTone =
  | "primary"
  | "accent"
  | "success"
  | "warning"
  | "error"
  | "danger"
  | "neutral";

type PillProps = {
  label?: string;
  children?: React.ReactNode;
  tone?: PillTone;
};

const toneStyles: Record<
  PillTone,
  { background: string; color: string; border: string }
> = {
  primary: {
    background: adminTheme.color.primaryBg,
    color: adminTheme.color.primaryText,
    border: adminTheme.color.primaryBorder,
  },
  accent: {
    background: adminTheme.color.accentBg,
    color: adminTheme.color.accentText,
    border: adminTheme.color.accentBorder,
  },
  success: {
    background: adminTheme.color.successBg,
    color: adminTheme.color.successText,
    border: adminTheme.color.successBorder,
  },
  warning: {
    background: adminTheme.color.warningBg,
    color: adminTheme.color.warningText,
    border: adminTheme.color.warningBorder,
  },
  error: {
    background: adminTheme.color.errorBg,
    color: adminTheme.color.errorText,
    border: adminTheme.color.errorBorder,
  },
  danger: {
    background: adminTheme.color.errorBg,
    color: adminTheme.color.errorText,
    border: adminTheme.color.errorBorder,
  },
  neutral: {
    background: adminTheme.color.surfaceMuted,
    color: adminTheme.color.textMuted,
    border: adminTheme.color.border,
  },
};

export default function Pill({
  label,
  children,
  tone = "primary",
}: PillProps) {
  const content = children ?? label;
  const styles = toneStyles[tone];

  if (!content) {
    return null;
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "8px 12px",
        borderRadius: adminTheme.radius.pill,
        background: styles.background,
        color: styles.color,
        fontSize: adminTheme.type.pill,
        fontWeight: 800,
        lineHeight: 1,
        letterSpacing: "0.01em",
        whiteSpace: "nowrap",
        border: `1px solid ${styles.border}`,
      }}
    >
      {content}
    </span>
  );
}